import { getCachedViewSnapshot } from '@databases/database-state/state/view';
import { DatabaseLayoutType } from '@databases/types/database/view';
import { type DatabaseChangeType } from '@databases/types/redux';

import {
  getOrderWithFallback,
  getViewSpecificOrderingExperimentValue
} from '../../../../database/view/view.ts';
import { type YJSChangeHandler } from '../../types.ts';

export const reorderEntries: YJSChangeHandler<DatabaseChangeType.REORDER_ENTRIES> = ({
  ydb,
  change
}) => {
  ydb.mutate((db) => {
    if (!getViewSpecificOrderingExperimentValue({ fireExperimentExposure: true })) {
      db.reorderEntries(change.entryIds, change.newIndex);
      return;
    }

    const view = getCachedViewSnapshot();
    if (!(view.id in db.viewsById)) {
      return;
    }

    const currentOrder = getOrderWithFallback(
      db.entries,
      db.viewOrders[view.id]?.entryOrder
    );
    if (!change.entryIds.every((entryId) => currentOrder.includes(entryId))) {
      return;
    }

    const globalAnchor = db.entries[change.newIndex];
    const requestedIndex =
      view.settings.layout.type === DatabaseLayoutType.BOARD
        ? globalAnchor
          ? currentOrder.indexOf(globalAnchor)
          : currentOrder.length
        : change.newIndex;
    const newIndex = Math.min(currentOrder.length, Math.max(0, requestedIndex));

    db.setViewEntryOrder(view.id, [
      ...currentOrder
        .slice(0, newIndex)
        .filter((entryId) => !change.entryIds.includes(entryId)),
      ...change.entryIds,
      ...currentOrder
        .slice(newIndex)
        .filter((entryId) => !change.entryIds.includes(entryId))
    ]);
  });
};
